const NonBreakingHyphenRule = ({ item }) => {
  if (typeof item?.teaserText === 'string' && item.teaserText.toLowerCase().indexOf('net-a-porter') > -1) {
    return {
      item: {
        ...item,
        teaserText: item.teaserText.replace(/NET-A-PORTER/g, 'NET\u2011A\u2011PORTER')
      }
    }
  }
}

export default NonBreakingHyphenRule 